import { cva } from 'class-variance-authority';

export const cvaProfileItemsList = cva([
  'ProfileItemsListStyles-cvaProfileItemsList',
  'flex flex-col',
  'gap-1.6',
]);

export const cvaProfileAltItem = cva([
  'ProfileItemsListStyles-cvaProfileItemsList',
  'flex',
  'gap-0.8',
]);
